/*
 * wc-reviews-lazy.js
 * -----------------------------------------------------------------------------
 * Defers the heavy PDP review widget so ~150 review cards + the customer-photo
 * grid stay out of the initial DOM/paint on every product page (most visitors
 * never scroll that far). The section wraps the generated widget markup in:
 *
 *   <div data-wc-reviews-mount style="min-height:…">
 *     <template data-wc-reviews-body> …generated widget incl. its inline IIFE… </template>
 *   </div>
 *
 * Content inside a <template> is inert: no layout, no paint, no image fetches,
 * no live DOM nodes, and its <script> does not run. We clone it into the live
 * DOM (and re-create its <script> so it executes) only when the user scrolls
 * near it — or clicks the title-area review summary that jumps down to it.
 *
 * Important: this file touches NOTHING that build-reviews.py generates. It only
 * pairs with the section wrappers, so a future review regeneration won't undo it.
 */
(function () {
  'use strict';

  var mount = document.querySelector('[data-wc-reviews-mount]');
  if (!mount) return;
  var tpl = mount.querySelector('template[data-wc-reviews-body]');
  if (!tpl) return;

  var loaded = false;
  var io = null;

  function activate() {
    if (loaded) return;
    loaded = true;
    if (io) io.disconnect();

    // Move the inert template content into the live DOM.
    mount.appendChild(tpl.content.cloneNode(true));

    // Cloned/parsed <script> nodes never execute on insertion — recreate them
    // so they run. The widget's inline IIFE then wires up filters, show-more,
    // the photo lightbox, and the summary-jump against the now-live DOM.
    var scripts = mount.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      var fresh = document.createElement('script');
      if (old.src) {
        fresh.src = old.src;
      } else {
        fresh.textContent = old.textContent;
      }
      old.parentNode.replaceChild(fresh, old);
    }

    tpl.remove();
    mount.style.minHeight = ''; // release the reserved space
  }

  // Primary trigger: load a little before it enters the viewport so the
  // content is usually present by the time the user reaches it.
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { activate(); break; }
      }
    }, { rootMargin: '800px 0px' });
    io.observe(mount);
  } else {
    // No IntersectionObserver support → just render it (don't gate reviews behind
    // a feature the browser lacks).
    activate();
  }

  // Secondary trigger: the title-area "★ 4.83 from N reviews" summary lives
  // OUTSIDE the deferred widget, and the handler that scrolls down to the widget
  // is INSIDE the deferred script. So before the first load we must load + scroll
  // ourselves; after load, the widget's own handler takes over.
  var summary = document.querySelector('.wc-review-summary-inline');
  if (summary) {
    summary.addEventListener('click', function (e) {
      if (loaded) return;
      e.preventDefault();
      activate();
      requestAnimationFrame(function () {
        var widget = document.getElementById('wc-reviews-widget') || mount;
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
})();
